var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h1',[_vm._v("Pin Simple")]),_c('a',{attrs:{"href":_vm.loginURI}},[_vm._v("\n    Login to Pinterest\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }